module.exports = __webpack_public_path__ + "static/img/bg11.693734e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/model/Images/bg11.jpg
// module id = 6DPF
// module chunks = 1